import { SchemaFormDefinition } from '@mews-commander/form';
import { lt } from '@mews/framework';
import { schema } from './schema';

export const formDefinition = {
    fields: {
        title: {
            label: lt('Title'),
        },
        note: {
            label: lt('Note'),
            field: { type: 'textarea' },
        },
        isReadyToGoLive: {
            label: lt('GoLiveAuditsActivityLogReadyToGoLive'),
            helper: lt('GoLiveAuditsActivityLogReadyToGoLiveHelperText'),
            field: { type: 'switch' },
        },
    },
} satisfies SchemaFormDefinition<typeof schema>;
